// extracted by mini-css-extract-plugin
export default {"popper":"AppTooltip_popper__IwjEM","root":"AppTooltip_root__4zFpV"};